<template>
  <router-view/>
  <global-toast-container></global-toast-container>
  <global-confirmation-container></global-confirmation-container>
</template>
